// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-el-icon[data-v-18eeea00]{color:currentColor;width:1em;height:1em}", ""]);
// Exports
module.exports = exports;
